// Domains of clients that bought the software outright - no TabL branding is shown there.
// Kept free of imports so reducers can use it too (Utils imports the store).
const BOUGHT_DOMAINS = ['bohemi-pamporovo.bg', 'bohemi-pamporovo.com'];

export const isBoughtDomain = () => {
	const host = (window.location.hostname || '').toLowerCase().replace(/^www\./, '');
	return BOUGHT_DOMAINS.some(domain => host === domain || host.endsWith('.' + domain));
}

// 1x1 transparent image - placeholder instead of the TabL logo until the place's own logo loads
export const TRANSPARENT_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

// On a bought domain a TabL image (the default before settings load, or an unset logo) is never shown
export const withoutTablLogo = (src) => {
	return isBoughtDomain() && /(^|\/\/)tabl\.bg\/img\//.test(src || '') ? TRANSPARENT_IMAGE : src;
}
